import { IFetchListArgs } from "../../stores/abstract-paged-data-store";
import { IReturnMethod } from "../return-methods/return-method-types";
import { IRma, IRmaProductCase, IRmaShipment, SHIPMENT_STATUS_ENUM } from "../manage-returns/rma-page/rma-types";

export const SHIPMENT_STATUS_TRANSLATION_KEYS_MAP = {
    [SHIPMENT_STATUS_ENUM.PENDING_SHIPMENT]: 'Pending',
	[SHIPMENT_STATUS_ENUM.LABEL_CREATED]: 'Label created',
	[SHIPMENT_STATUS_ENUM.SHIPPED]: 'In Transit',
    [SHIPMENT_STATUS_ENUM.RECEIVED]: 'Delivered',
    [SHIPMENT_STATUS_ENUM.REJECTED]: 'Delivery Failed',
    [SHIPMENT_STATUS_ENUM.VERIFIED]: 'Delivered',
    [SHIPMENT_STATUS_ENUM.OUT_FOR_DELIVERY]: 'Out for Delivery',
	[SHIPMENT_STATUS_ENUM.ERROR]: 'Label not created',
} as const;

export interface IShipment extends IRmaShipment{
    return_id: string;
    address: string | null;
    deleted_at: string | null;
    created_at: string | null;
    updated_at: string | null;
    return_label_setting_id: number | null;
    user_id: string | null;
    notified_status: string | null;
    last_notification_type_sent: string | null;
    order_number: string | null;
    create_date: string | null;
    customer_name: string | null;
    customer_email: string | null;
    customer_state: string;
    customer_country: string;
    customer_phone: string | null;
    shipment_cost: string | null;
    shipstation_rma_id: string | null;
    last_tracked_status: string | null;
    notified_date: string | null;
    last_tracking_date: string | null;
    actual_shipment_date: string | null;
    expected_delivery_date: string | null;
    delivery_date: string | null;
    carrier: string;
    qr_code_id: string | null;
    actual_shipment_details: string | null;
    closest_drop_off_location_id: string | null;
    shipping_connection_id: number | null;
    external_id: string;
    reverse_delivery_id: string | null;
    return_method_id: string;
    label_cost: number | null;
    label_cost_currency: string | null;
    return_method?: IReturnMethod;
    shipping_connections: any | null;
    product_case: IRmaProductCase[] | null;
    _customerUrl: string | null;
    _orderUrl: string | null;
    rma_data?: IRma;
};

export interface IFetchShipmentsListArgs extends IFetchListArgs {
    search_input: string,
    filter_status: SHIPMENT_STATUS_ENUM[] | null,
    filter_carrier_id: string[] | null,
    filter_connection_id: string[] | null,
    filter_create_date: string,
    filter_order_or_rma_create_date: string,
    filter_delivery_date: string,
    filter_last_update_date: string,
}